<template>
    <base-modal v-if="harjaModal" size="lg" hide-footer :title="getTitle(harjaType)" @close="hideModal">
      <div class="col-sm-12 form-data" @click.stop="">
        <div class="col-sm-12 nopads">
          <span class="span-title">{{ $t('harja.free_text') }}</span>
            <textarea
                id="areaName"
                v-model="freetext"
                rows="3"
                class="form-control form-control-sm">
            </textarea>
        </div>
        <div class="col-sm-12 button-container">
          <button class="btn btn-secondary form-button" @click.stop="hideModal">
            {{ $t('common.cancel') }}
          </button>
          <button class="btn btn-success form-button" :disabled="loading" @click.stop="postHarjaKuittaus">
            {{ $t('common.send') }}
          </button>
        </div>
      </div>
      <div
        v-if="loading"
        id="loader"
        class="spinner"
      />
    </base-modal>
</template>

<script>

import {restApi} from "@/components/mixins/RestApiMixin";
import {timeUtils} from "@/components/mixins/TimeUtils";
import BaseModal from "@/components/BaseModal";
import {inject} from "vue";

export default {
    name: 'HarjaSendModal',
    components: {BaseModal},
    mixins: [restApi, timeUtils],
    props: {
        harjaType: {
            type: String,
            return: null,
        },
        harjaId: {
            type: Number,
            return: null,
        },
        contract: {
            type: Number,
            return: null,
        },
    },
    data() {
        return {
            loading: false,
            freetext: null,
            harjaModal: false
        }
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    methods: {
        hideModal: function () {
            this.freetext = null
            this.harjaModal = false
        },
        getTitle: function (key) {
            switch (key) {
                case 'vastaanotto': return this.$t('harja.receive')
                case 'aloitus': return this.$t('harja.start')
                case 'muutos': return this.$t('harja.change')
                case 'lopetus': return this.$t('harja.end')
                case 'vastaus': return this.$t('harja.answer')
            }
            return ' '
        },
        async postHarjaKuittaus() {
            let params = {}
            params.freetext = this.freetext
            params.receipt = this.harjaType
            params.contract = this.contract
            this.loading = true
            this.restUpdate(this.harjaAlertUrl + '/' + this.harjaId, params, this.putSuccess, this.putFailed);
        },
        close: function () {
            this.$emit('close')
        },
        putSuccess: function () {
            this.loading = false
            this.showAlert(this.$t('common.alert_add_success'), 'success')
            this.$emit('submitted')
            this.harjaModal = false
        },
        putFailed: function () {
            this.loading = false
            this.showAlert(this.$t('common.alert_update_failed'))
        },
        show() {
            this.harjaModal = true
        }
    }
}
</script>

<style scoped>

</style>
